import {Alert, DatePicker, Form, Modal, notification, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'redux-scaffolding-ts';
import {formatMessage} from '../../../../core/services/http.service';
import {NewProjectTemplateItem, NewProjectTemplateStore} from '../../../../stores/templates-store';
import ProjectTemplateFormBody from './project-template-form-body';

let FormItem = Form.Item;
let { RangePicker } = DatePicker;

interface NewProjectTemplateViewProps {
    companyId: string,
    onClose: (id: string | undefined, item?: NewProjectTemplateItem) => void;
    onOk?: (id: string | undefined) => void
}

interface NewProjectTemplateViewState {
    isCreationModalOpen: boolean,
}




@connect(["newProjectTemplateStore", NewProjectTemplateStore])
class NewProjectTemplateView extends React.Component<NewProjectTemplateViewProps & WithTranslation & FormComponentProps, NewProjectTemplateViewState> {
    private get NewProjectTemplateStore() {
        return (this.props as any).newProjectTemplateStore as NewProjectTemplateStore;
    }

    constructor(props: NewProjectTemplateViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.NewProjectTemplateStore.createNew({} as any);
    }

    @autobind
    componentWillMount() {
        this.NewProjectTemplateStore.changeUrl(this.props.companyId)
    }

    componentWillReceiveProps(nextProps: NewProjectTemplateViewProps) {
        if (this.NewProjectTemplateStore.state.result && this.NewProjectTemplateStore.state.result.isSuccess)
            this.props.onClose((this.NewProjectTemplateStore.state.result as any).aggregateRootId, this.NewProjectTemplateStore.state.item)
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private onCreateNewItem() {
        const { t } = this.props;
        return new Promise((resolve, reject) => {
            this.props.form.validateFields(event => {
                var values = this.props.form.getFieldsValue();
                if (!event) {
                    values = { ...values, companyId: this.props.companyId };
                    this.NewProjectTemplateStore.change(values);
                    this.NewProjectTemplateStore.submit().then(result => {
                        if (this.props.onOk) this.props.onOk(result.identifier)
                        if (result.isSuccess) {
                            this.countDownNotification(notification.success, t("Notification"), t("Operation completed successfully"), "success");
                            resolve();
                        } else {
                            reject();
                            this.countDownNotification(notification.error, t("Error"), t("There was an error"), "failure");
                        }
                    });
                }
            });
        })
    }

    @autobind
    private onCancelNewItem() {
        this.NewProjectTemplateStore.clear();
        this.props.onClose(undefined);
    }

    public render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;
        return (
            <Modal
                maskClosable={false}
                visible
                onCancel={this.onCancelNewItem}
                onOk={this.onCreateNewItem}
                closable={false}
                width='800px'
                okText={t("OK")}
                cancelText={t("Cancel")}
                title={t("New project template")}>
                {this.NewProjectTemplateStore.state.result && !this.NewProjectTemplateStore.state.result.isSuccess &&
                    <Alert type='error'
                        message={t("Error")}
                        description={t(formatMessage(this.NewProjectTemplateStore.state.result))}
                    />
                }
                <Spin spinning={this.NewProjectTemplateStore.state.isBusy}>
                    <Form id="taskTemplateForm" onKeyUp={(e) => { if (e.keyCode === 13) { this.onCreateNewItem(); } }}>
                        <ProjectTemplateFormBody
                            i18n={this.props.i18n}
                            t={this.props.t}
                            tReady={this.props.tReady}
                            item={this.NewProjectTemplateStore.state.item}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(NewProjectTemplateView as any) as any) as any as React.ComponentClass<NewProjectTemplateViewProps>;